(function () {
  function base() { return (window.tkBuyback && window.tkBuyback.baseUrl) || 'https://dashboard.tekrevive.com.au'; }

  async function call(path, opts) {
    opts = opts || {};
    const init = Object.assign({}, opts);
    init.headers = Object.assign({}, opts.headers || {});
    if (opts.body != null && !init.headers['Content-Type']) init.headers['Content-Type'] = 'application/json';
    const res = await fetch(base() + path, init);
    let body;
    try { body = await res.json(); } catch (_) { throw new Error('Network error'); }
    if (!body.ok) {
      const err = body.error || {};
      const msg = err.message || ('HTTP ' + res.status);
      const e = new Error(msg);
      e.code = err.code; e.details = err.details; e.status = res.status;
      throw e;
    }
    return body.data;
  }

  // RMS direct call — returns the legacy envelope shape
  async function rmsCall(path, opts) {
    opts = opts || {};
    const init = Object.assign({}, opts);
    init.headers = Object.assign({ 'Content-Type': 'application/json' }, opts.headers || {});
    const res = await fetch(base() + path, init);
    let body;
    try { body = await res.json(); } catch (_) { throw new Error('Network error'); }
    if (!res.ok) {
      if (typeof console !== 'undefined') console.error('[RMS ' + res.status + ']', path, JSON.stringify(body));
      var err = body && body.error;
      var msg;
      if (err && err.code === 'VALIDATION' && err.details) {
        var fe = err.details.fieldErrors || {};
        var parts = Object.keys(fe).map(function (k) {
          var v = fe[k]; return k + ': ' + (Array.isArray(v) ? v[0] : v);
        });
        msg = parts.length ? parts.join(' | ') : (err.message || 'Validation failed');
      } else {
        msg = (err && err.message) || (body && typeof body.message === 'string' && body.message) || ('HTTP ' + res.status);
      }
      throw Object.assign(new Error(msg), { status: res.status, code: err && err.code });
    }
    return body.result != null ? body.result : body;
  }

  function fmtMoney(cents) {
    try { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', maximumFractionDigits: 0 }).format(cents / 100); }
    catch (e) { return '$' + Math.round(cents / 100).toLocaleString(); }
  }

  function parsePrice(s) {
    if (!s) return 0;
    const n = parseFloat(String(s).replace(/,/g, ''));
    if (!isFinite(n)) return 0;
    return Math.round(n * 100);
  }

  // First-touch marketing attribution: record the ad/campaign params + referrer
  // once per browser, so the lead carries where the customer came from even after
  // they navigate around the site. Never overwritten (first touch wins).
  function captureAttribution() {
    try {
      var KEY = 'tk-attribution';
      if (localStorage.getItem(KEY)) return;
      var p = new URLSearchParams(window.location.search);
      var ref = document.referrer || '';
      var external = ref && ref.indexOf(window.location.host) === -1;
      var a = {
        utm_source: p.get('utm_source') || undefined,
        utm_medium: p.get('utm_medium') || undefined,
        utm_campaign: p.get('utm_campaign') || undefined,
        utm_content: p.get('utm_content') || undefined,
        utm_term: p.get('utm_term') || undefined,
        gclid: p.get('gclid') || undefined,
        fbclid: p.get('fbclid') || undefined,
        referrer: external ? ref : undefined,
        landing: window.location.pathname + (window.location.search || ''),
      };
      // Only persist a paid/referred touch — a plain direct visit carries no attribution.
      if (a.utm_source || a.gclid || a.fbclid || a.referrer) {
        localStorage.setItem(KEY, JSON.stringify(a));
      }
    } catch (_) {}
  }
  function readAttribution() {
    try { return JSON.parse(localStorage.getItem('tk-attribution') || 'null') || undefined; }
    catch (_) { return undefined; }
  }
  captureAttribution();

  // Map theme createQuote payload → RMS offer/mail-in. The storefront is buyback
  // mail-in only; staff in-store counter offers are created in the admin, never here.
  // A customer "drop off in-store" is still a mail-in offer — same pipeline — they
  // just carry the device to a store instead of posting it, so we tag the chosen
  // store as fulfillment metadata and skip the shipping address.
  async function rmsCreateOffer(payload) {
    const isDropoff = payload.fulfillment === 'in_store';
    const offerDetail = (payload.devices || []).map(function (d) {
      var desc = ((d.brand || '') + ' ' + (d.model || '')).trim().slice(0, 200) || 'Device';
      return {
        product_id: d.productId,
        condition_id: d.conditionId,
        qty: 1,
        name: (d.model || desc).slice(0, 200),
        description: desc,
        questions: d.questions || [],
        specifications: d.specifications || [],
        imei: d.declaredImei || undefined,
        is_custom_buyback: 0,
        is_recycle: 0,
      };
    });

    var nameParts = (payload.customerName || '').trim().split(/\s+/);
    var firstname = payload.customerFirstName || nameParts[0] || payload.customerEmail.split('@')[0];
    var lastname = payload.customerLastName || (nameParts.length > 1 ? nameParts.slice(1).join(' ') : '-');

    var rmsPayload = {
      customer_email: payload.customerEmail,
      customer_firstname: firstname,
      customer_lastname: lastname,
      customer_phone: payload.customerPhone || undefined,
      payout_method: mapPayoutMethod(payload.payoutMethod),
      tf_full_name: payload.bankAccountName || undefined,
      tf_routing_number: payload.bankRoutingNumber || undefined,
      tf_account_number: payload.bankAccountNumber || undefined,
      paypal_address: payload.paypalEmail || undefined,
      payid: payload.payId || undefined,
      shipping_country: 'AU',
      offer_detail: offerDetail,
    };
    if (payload.couponCode) rmsPayload.coupon_code = String(payload.couponCode).trim().toUpperCase();
    // Extra Cover (optional shipping insurance) applies to posted devices only.
    if (payload.extraCover === true && payload.fulfillment !== 'in_store') {
      rmsPayload.extra_cover = true;
      if (typeof payload.extraCoverFeeCents === 'number') rmsPayload.extra_cover_fee_cents = payload.extraCoverFeeCents;
    }

    // Pass the abandon-tracking lead box so the backend removes that placeholder
    // once the real offer is created (avoids a duplicate $0 lead in admin).
    try {
      var leadToken = sessionStorage.getItem('tk-lead-token');
      if (leadToken) rmsPayload.offer_token = leadToken;
    } catch (_) {}

    if (isDropoff) {
      rmsPayload.fulfillment = 'dropoff';
      rmsPayload.dropoff_location_id = parseInt(payload.storeLocationId, 10) || 1;
    } else {
      rmsPayload.fulfillment = 'post';
      rmsPayload.shipping_firstname = firstname;
      rmsPayload.shipping_lastname = lastname;
      rmsPayload.shipping_address1 = payload.shippingAddress1 || '';
      rmsPayload.shipping_address2 = payload.shippingAddress2 || '';
      rmsPayload.shipping_city = payload.shippingCity || '';
      rmsPayload.shipping_state = payload.shippingState || '';
      rmsPayload.shipping_zip = payload.shippingZip || '';
    }

    var result = await rmsCall('/v1/trade-in/offer/mail-in', { method: 'POST', body: JSON.stringify(rmsPayload) });
    try { sessionStorage.removeItem('tk-lead-token'); } catch (_) {}

    // Return in the shape offer-received.liquid expects
    var totalCents = (payload.devices || []).reduce(function (s, d) { return s + (d.price ? parsePrice(String(d.price)) : 0); }, 0);
    // RMS adds the promo bonus unless it declines the code (coupon_rejected).
    if (payload.couponCode && !result.coupon_rejected) totalCents += Number(payload.couponAmountCents) || 0;
    return {
      boxId: result.box_id || '',
      offerId: result.offer_id || result.box_id || '',
      portalToken: result.token || null,
      shippingLabelUrl: result.shipping_kit_link || null,
      totalCents: String(totalCents),
      couponRejected: result.coupon_rejected || null,
      items: (payload.devices || []).map(function (d, i) {
        return { id: result.offer_id + '-' + i, offerCents: String(d.price ? parsePrice(String(d.price)) : 0), status: 'QUOTED', declaredImei: d.declaredImei || null };
      }),
      id: result.offer_id || result.box_id || '',
      offerCents: String((payload.devices || [])[0] ? parsePrice(String((payload.devices || [])[0].price || 0)) : 0),
    };
  }

  // Get offer by box ID from RMS portal
  async function rmsGetByBox(boxId) {
    var result = await rmsCall('/v1/trade-in/offer/easy-offer/' + encodeURIComponent(boxId));
    return {
      boxId: result.boxId || boxId,
      status: result.status,
      totalCents: String(Number(result.totalCents || 0)),
      shippingLabelUrl: result.shippingLabelUrl || null,
      portalToken: null,
      items: (result.items || []).map(function (it) {
        return { id: it.id, offerCents: String(Number(it.priceCents || 0)), status: result.status, declaredImei: it.imeiSn || null };
      }),
    };
  }

  function mapPayoutMethod(method) {
    var map = { 'Bank Transfer': 'Bank Transfer', 'bank': 'Bank Transfer', 'PayPal': 'PayPal', 'paypal': 'PayPal', 'PayID': 'PayID', 'payid': 'PayID', 'Store Credit': 'Store Credit' };
    return map[method] || 'Choose Later';
  }

  // Capture lead when user reaches payout step — stores offer_token for abandon tracking
  async function rmsCaptureLead(payload) {
    // Drop-off ('in_store' fulfillment) is just how the customer delivers the
    // device — still a mail-in/standard buyback, never an in-store offer.
    var isInStore = false;
    var nameParts = (payload.customerName || '').trim().split(/\s+/);
    var firstname = payload.customerFirstName || nameParts[0] || '';
    var lastname = payload.customerLastName || (nameParts.length > 1 ? nameParts.slice(1).join(' ') : undefined);
    var offerDetail = (payload.devices || []).map(function (d) {
      var specs = d.specSelections || {};
      var faults = Array.isArray(d.faults) ? d.faults.map(function (f) {
        return {
          label: f.label || f.name || f.answer || undefined,
          type: f.type || undefined,
          // d.price and fault amounts are already in cents — never parsePrice them (that would ×100).
          amount_cents: f.amount != null ? Math.round(Number(f.amount)) : undefined,
        };
      }).filter(function (f) { return f.label; }) : undefined;
      return {
        product_id: d.productId,
        condition_id: d.conditionId || undefined,
        qty: 1,
        notes: d.condition || undefined,
        // Indicative (client-computed) quote + readable device context for the lead.
        price_cents: d.price != null ? Math.round(Number(d.price)) : undefined,
        model_name: d.deviceName || ((d.brand || '') + ' ' + (d.model || '')).trim() || undefined,
        brand: d.brand || undefined,
        storage: specs.size || undefined,
        network: specs.network || undefined,
        condition_name: d.condition || undefined,
        faults: faults && faults.length ? faults : undefined,
        image: d.image || undefined,
      };
    }).filter(function (it) { return it.product_id; });
    var attribution = readAttribution();
    var offerToken;
    try { offerToken = sessionStorage.getItem('tk-lead-token') || undefined; } catch (_) {}
    var totalCents = (payload.devices || []).reduce(function (s, d) {
      return s + (d.price != null ? Math.round(Number(d.price)) : 0);
    }, 0);
    try {
      var result = await rmsCall('/v1/trade-in/offer/leads', {
        method: 'POST',
        body: JSON.stringify({
          customer_email: payload.customerEmail,
          customer_firstname: firstname || undefined,
          customer_lastname: lastname || undefined,
          customer_phone: payload.customerPhone || undefined,
          buyback_type: isInStore ? 2 : 1,
          offer_detail: offerDetail,
          total_cents: totalCents || undefined,
          fulfillment: payload.fulfillment || undefined,
          store_location_id: payload.storeLocationId || undefined,
          address_line1: payload.addressLine1 || undefined,
          address_line2: payload.addressLine2 || undefined,
          address_suburb: payload.addressSuburb || undefined,
          address_state: payload.addressState || undefined,
          address_postcode: payload.addressPostcode || undefined,
          step_reached: payload.stepReached || 2,
          coupon_code: payload.couponCode ? String(payload.couponCode).trim().toUpperCase() : undefined,
          offer_token: offerToken,
          attribution: attribution,
          source: (attribution && attribution.utm_source) || 'submit-offer',
          referral_source: (attribution && attribution.referrer) || undefined,
        }),
      });
      // Persist offer_token so final submit can skip duplicate
      if (result && result.box_id) {
        try { sessionStorage.setItem('tk-lead-token', result.box_id); } catch (_) {}
      }
      return result;
    } catch (_) {
      // Lead capture is best-effort — never block the user flow
    }
  }

  window.TKBuyback = {
    base: base,
    captureLead: rmsCaptureLead,
    // Highest drop-off bonus (cents) for a set of catalog category slugs given the tiers
    // map from dropoffBonus(). Mirrors the backend bonusAmountForCategories.
    bonusAmountForCategories: function (slugs, tiers) {
      var max = 0; tiers = tiers || {};
      (slugs || []).forEach(function (s) { var c = tiers[s]; if (typeof c === 'number' && c > max) max = c; });
      return max;
    },
    // Fast drop-off bonus config from RMS (single source of truth for the badge +
    // final-card note). Cached per page; resolves null on error so callers fail closed.
    dropoffBonus: (function () {
      var cached = null;
      return function () {
        if (!cached) cached = call('/v1/trade-in/offer/dropoff-bonus').catch(function () { return null; });
        return cached;
      };
    })(),
    getSpecs: function (brand, model, params) {
      var qs = '';
      if (params && typeof params === 'object') {
        var pairs = Object.keys(params)
          .filter(function (k) { return params[k] != null && params[k] !== ''; })
          .map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]); });
        if (pairs.length) qs = '?' + pairs.join('&');
      }
      return call('/v1/trade-in/catalog/specs/' + encodeURIComponent(brand) + '/' + encodeURIComponent(model) + qs);
    },
    getVariants: function (brand, model) {
      return call('/v1/trade-in/catalog/variants/' + encodeURIComponent(brand) + '/' + encodeURIComponent(model));
    },
    customerExists: function (email) {
      return call('/v1/trade-in/customer-exists?email=' + encodeURIComponent(email));
    },
    // { valid, code, amountCents } — the code's own check; "first offer" is decided when the offer is created.
    validateCoupon: function (code) {
      return call('/v1/trade-in/coupon/validate?code=' + encodeURIComponent(code));
    },
    createQuote: function (payload) {
      return rmsCreateOffer(payload);
    },
    getQuote: function (id) { return call('/v1/trade-in/quotes/' + encodeURIComponent(id)); },
    getByBox: function (boxId) {
      return rmsGetByBox(boxId);
    },
    acceptQuote: function (id) {
      return rmsCall('/v1/portal/' + encodeURIComponent(id) + '/accept', { method: 'POST' });
    },
    uploadImages: function (boxId, images, portalToken) {
      if (!portalToken) return Promise.reject(new Error('Portal session expired. Open the offer status link to upload photos.'));
      return images.reduce(function (chain, image) {
        return chain.then(function () {
          return rmsCall('/v1/trade-in/portal/upload-image', {
            method: 'POST',
            headers: { Authorization: 'Bearer ' + portalToken },
            body: JSON.stringify({
              dataBase64: 'data:image/jpeg;base64,' + image.base64,
              filename: image.filename,
              contentType: image.contentType,
            })
          });
        });
      }, Promise.resolve());
    },
    fmtMoney: fmtMoney,
    parsePrice: parsePrice
  };
})();
